"use strict";

(function(){

var self = Fotobook.book.emptyCaptions = {
    /**
     * Просчитать и установить размер текста-заглушки пустого контейнера
     */
    fitEmptyCaptionText: function(){
        var p = $(this),
            $parent = p.parent('.text-container'),
            w, h, fs,
            c = 14;

        w = $parent.width();
        h = $parent.height();

        if (w > 6 * h) {
            fs = 5 * h / c;
        } else {
            fs = w / c;
        }

        this.css("font-size", Math.floor(fs));
    },

    recalcCustomPlaceholder: function(){
        var $this = this,
            $text = $this.find(".empty-text-placeholder-text"),
            $cont = $this.closest(".text-container"),
            $caption = $cont.find(".caption").first(),
            $textContent = $caption.find(".text-content").first();

        $this.attr("style", $caption.attr("style"));
        $text.attr("style", $textContent.attr("style")).css("line-height", $caption.attr("data-line-height")+"%");
    },

    _emptyCaptionPlaceholder: [
        '<div class="{classes}">',
            '<div class="empty-text-placeholder-text">',
                '{placeholder}',
            '</div>',
        '</div>'
    ].join(""),

    /**
     * Установить текст-заглушку
     */
    setupEmptyCaption: function () {
        var $e = $(this),
            classes = ["empty-text-placeholder"],
            language_key = $e.attr("data-language-key"),
            translated_key, placeholder, text;

        if (language_key) {
            translated_key = t($e.attr("data-language-key"));
        }

        // в продакт-режиме вместо непереведённых ключей используем стандартную заглушку
        if (translated_key && !(Fotobook.config.data.debug && translated_key.match(/^\{photobook-.*\}$/))) {
            placeholder = $($.parseHTML(translated_key)).text().escapeHtml();

            classes.push("empty-text-placeholder-custom");
        } else {
            placeholder = t("photobook-js-captinClickToEdit");
            classes.push("empty-text-placeholder-common");
        }
        text = self._emptyCaptionPlaceholder.supplant({
            "classes": classes.join(" "),
            "placeholder": placeholder,
        });

        $e.prepend(text);
        self.recalcPlaceholder.call($e);
    },

    recalcPlaceholder: function(){
        $(this).find(".empty-text-placeholder").each(function(){
            var $this = $(this);
            if ($this.hasClass("empty-text-placeholder-common")){
                self.fitEmptyCaptionText.call($this);
            } else {
                self.recalcCustomPlaceholder.call($this);
            }
        });
    },
};

$(document)
.on(Fotobook.events.SETUP_BOOK_CONTAINER, ".text-container", self.setupEmptyCaption)
.on(Fotobook.events.RECALC_CONTAINER, ".text-container", self.recalcPlaceholder)
.on(Fotobook.events.ONLINE_EDITOR_INIT_DATA, function(event, initData){
    Fotobook.i18n.setTranslations(initData.captionPlaceholders, "captionPlaceholders");
})
.on(Fotobook.events.AJAX_DONE, function(event, result, response){
    if (response && response.data && response.data.captionPlaceholders){
        Fotobook.i18n.setTranslations(response.data.captionPlaceholders, "captionPlaceholders");
    }
})
;

})();
